import React, { useState, useEffect } from 'react';
import { useReservations } from '../ReservationContext';

const ZoneModal = ({ isOpen, mode, zone, onClose }) => {
  const { loading, createZone, updateZone } = useReservations();

  const [formData, setFormData] = useState({
    zone_id: '',
    zone_name: '',
    floor: 1,
    description: '',
    is_private_room: false,
    requires_event_check: false,
    min_party_size: 1,
    max_party_size: 50,
  });

  useEffect(() => {
    if (mode === 'edit' && zone) {
      setFormData({
        zone_id: zone.zone_id,
        zone_name: zone.zone_name,
        floor: zone.floor || 1,
        description: zone.description || '',
        is_private_room: zone.is_private_room || false,
        requires_event_check: zone.requires_event_check || false,
        min_party_size: zone.min_party_size || 1,
        max_party_size: zone.max_party_size || 50,
      });
    } else {
      setFormData({
        zone_id: '',
        zone_name: '',
        floor: 1,
        description: '',
        is_private_room: false,
        requires_event_check: false,
        min_party_size: 1,
        max_party_size: 50,
      });
    }
  }, [mode, zone]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let success;
    if (mode === 'edit') {
      success = await updateZone(zone.zone_id, formData);
    } else {
      success = await createZone(formData);
    }
    if (success) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{mode === 'create' ? 'Add Zone' : 'Edit Zone'}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <form className="reservation-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>Zone ID *</label>
              <input
                type="text"
                value={formData.zone_id}
                onChange={(e) => setFormData({ ...formData, zone_id: e.target.value })}
                placeholder="private-room-1"
                required
                disabled={mode === 'edit'}
              />
            </div>
            <div className="form-group">
              <label>Zone Name *</label>
              <input
                type="text"
                value={formData.zone_name}
                onChange={(e) => setFormData({ ...formData, zone_name: e.target.value })}
                placeholder="Private Room 1"
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Floor</label>
              <select
                value={formData.floor}
                onChange={(e) => setFormData({ ...formData, floor: parseInt(e.target.value) })}
              >
                <option value={1}>Floor 1</option>
                <option value={2}>Floor 2</option>
                <option value={3}>Floor 3</option>
              </select>
            </div>
            <div className="form-group">
              <label>Private Room</label>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={formData.is_private_room}
                  onChange={(e) => setFormData({
                    ...formData,
                    is_private_room: e.target.checked,
                    requires_event_check: e.target.checked ? true : formData.requires_event_check
                  })}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>
          </div>

          <div className="form-group">
            <label>Description</label>
            <textarea
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              placeholder="Description of this seating zone..."
              rows="2"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Min Party Size</label>
              <input
                type="number"
                min="1"
                max="100"
                value={formData.min_party_size}
                onChange={(e) => setFormData({ ...formData, min_party_size: parseInt(e.target.value) })}
              />
            </div>
            <div className="form-group">
              <label>Max Party Size</label>
              <input
                type="number"
                min="1"
                max="100"
                value={formData.max_party_size}
                onChange={(e) => setFormData({ ...formData, max_party_size: parseInt(e.target.value) })}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={formData.requires_event_check}
                onChange={(e) => setFormData({ ...formData, requires_event_check: e.target.checked })}
              />
              Check for private events before allowing reservations
            </label>
            <span className="form-hint">
              When enabled, this zone will be blocked for regular reservations when a private event is scheduled
            </span>
          </div>

          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Saving...' : 'Save Zone'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ZoneModal;
